import {
  ISubmitData, ISubmitSuccessData, ISubmitFailData, ISilentSubmitData,
} from 'types';

export enum TYPES {
  SUBMIT = '[CALLBACK_REQUEST]-SUBMIT',
  SUBMIT_SUCCESS = '[CALLBACK_REQUEST]-SUBMIT_SUCCESS',
  SUBMIT_FAIL = '[CALLBACK_REQUEST]-SUBMIT_FAIL',
  RESET = '[CALLBACK_REQUEST]-RESET',

  SILENT_SUBMIT = '[CALLBACK_REQUEST]-SILENT-SUBMIT',
  SILENT_SUBMIT_SUCCESS = '[CALLBACK_REQUEST]-SILENT-SUBMIT_SUCCESS',
  SILENT_SUBMIT_FAIL = '[CALLBACK_REQUEST]-SILENT-SUBMIT_FAIL',

  SILENT_CONTACT_DETAILS_SUBMIT = '[CALLBACK_REQUEST]-CONTACT-DETAILS-SILENT-SUBMIT',
  SILENT_CONTACT_DETAILS_SUBMIT_SUCCESS = '[CALLBACK_REQUEST]-CONTACT-DETAILS-SILENT-SUBMIT_SUCCESS',
  SILENT_CONTACT_DETAILS_SUBMIT_FAIL = '[CALLBACK_REQUEST]-CONTACT-DETAILS-SILENT-SUBMIT_FAIL',
}

export type CallbackRequestActions =
  ISubmit |
  ISubmitSuccess |
  ISubmitFail |
  ISilentSubmit |
  ISilentSubmitSuccess |
  ISilentSubmitFail |
  ISilentContactDetailsSubmit |
  ISilentContactDetailsSubmitSuccess |
  ISilentContactDetailsSubmitFail |
  IReset;

// =====================
// Callback submit action
// =====================
export interface ISubmit {
  type: typeof TYPES.SUBMIT;
  payload: ISubmitData;
}

export function actionSubmit(submitData : ISubmitData): ISubmit {
  return {
    type: TYPES.SUBMIT,
    payload: {
      ...submitData,
    },
  };
}

export interface ISubmitSuccess {
  type: typeof TYPES.SUBMIT_SUCCESS;
  payload: ISubmitSuccessData;
}

export function actionSubmitSuccess({ success } : ISubmitSuccessData): ISubmitSuccess {
  return {
    type: TYPES.SUBMIT_SUCCESS,
    payload: {
      success,
    },
  };
}

export interface ISubmitFail {
  type: typeof TYPES.SUBMIT_FAIL;
  payload: ISubmitFailData;
}

export function actionSubmitError({ error } : ISubmitFailData): ISubmitFail {
  return {
    type: TYPES.SUBMIT_FAIL,
    payload: {
      error,
    },
  };
}

export interface IReset {
  type: typeof TYPES.RESET;
  payload: null;
}

export function actionReset(): IReset {
  return {
    type: TYPES.RESET,
    payload: null,
  };
}

// =====================
// Silent submit (used in the CallbackRequestModal if the user has filled out details but doesn't submit)
// =====================

export interface ISilentSubmit {
  type: typeof TYPES.SILENT_SUBMIT;
  payload: ISubmitData;
}

export function actionSilentSubmit(submitData : ISubmitData): ISilentSubmit {
  return {
    type: TYPES.SILENT_SUBMIT,
    payload: {
      ...submitData,
    },
  };
}

export interface ISilentSubmitSuccess {
  type: typeof TYPES.SILENT_SUBMIT_SUCCESS;
  payload: { hasSubmittedSilent: boolean };
}

export function actionSilentSubmitSuccess({ hasSubmittedSilent } : { hasSubmittedSilent: boolean }): ISilentSubmitSuccess {
  return {
    type: TYPES.SILENT_SUBMIT_SUCCESS,
    payload: {
      hasSubmittedSilent,
    },
  };
}

export interface ISilentSubmitFail {
  type: typeof TYPES.SILENT_SUBMIT_FAIL;
  payload: null;
}

export function actionSilentSubmitFail(): ISilentSubmitFail {
  return {
    type: TYPES.SILENT_SUBMIT_FAIL,
    payload: null,
  };
}

// =====================
// Silent submit (used in the ContactDetails page if the user has filled out details and moves to the next step)
// =====================

export interface ISilentContactDetailsSubmit {
  type: typeof TYPES.SILENT_CONTACT_DETAILS_SUBMIT;
  payload: ISilentSubmitData;
}

export function actionSilentContactDetailsSubmit(submitData : ISilentSubmitData): ISilentContactDetailsSubmit {
  return {
    type: TYPES.SILENT_CONTACT_DETAILS_SUBMIT,
    payload: {
      ...submitData,
    },
  };
}

export interface ISilentContactDetailsSubmitSuccess {
  type: typeof TYPES.SILENT_CONTACT_DETAILS_SUBMIT_SUCCESS;
  payload: { hasSubmittedContactDetailsSilent: boolean };
}

export function actionContactDetailsSubmitSuccess({ hasSubmittedContactDetailsSilent } : { hasSubmittedContactDetailsSilent: boolean }): ISilentContactDetailsSubmitSuccess {
  return {
    type: TYPES.SILENT_CONTACT_DETAILS_SUBMIT_SUCCESS,
    payload: {
      hasSubmittedContactDetailsSilent,
    },
  };
}

export interface ISilentContactDetailsSubmitFail {
  type: typeof TYPES.SILENT_CONTACT_DETAILS_SUBMIT_FAIL;
  payload: null;
}

export function actionContactDetailsSubmitFail(): ISilentContactDetailsSubmitFail {
  return {
    type: TYPES.SILENT_CONTACT_DETAILS_SUBMIT_FAIL,
    payload: null,
  };
}
